/**
 * The cost-estimate screen's route registration (frame 132:555), discovered
 * by `../routes.ts`'s glob. See `./paths.ts` for what it absorbed from the
 * retired burn-rate route.
 *
 * `CostEstimate` itself fails closed for a caller without
 * `control_plane.write` (its own module doc), pending
 * `owner-decisions-fs-campaign-record-and-accounts-analyst-credit-figures`.
 */

import { createElement, type ReactNode } from 'react';
import { Calculator } from 'lucide-react';
import { useParams } from '@tanstack/react-router';

import type { RouteBundle } from '../../routes/contract';
import { CostEstimate } from './CostEstimate';
import { et } from './messages';
import { ESTIMATE_PATH } from './paths';

const CONTROL_PLANE_READ = 'control_plane.read';

function useParamCampaignId(): string {
  const { campaignId } = useParams({ strict: false }) as { campaignId?: string };
  return campaignId ?? '';
}

function EstimateRoute(): ReactNode {
  const campaignId = useParamCampaignId();
  return createElement(CostEstimate, { campaignId });
}

export const bundle: RouteBundle = {
  routes: [
    {
      path: ESTIMATE_PATH,
      element: createElement(EstimateRoute),
      requires: CONTROL_PLANE_READ,
      kind: 'data',
    },
  ],
  nav: [],
  campaignNav: [
    {
      path: ESTIMATE_PATH,
      label: () => et('title'),
      requires: CONTROL_PLANE_READ,
      icon: Calculator,
      order: 100,
      kind: 'data',
    },
  ],
};
